import {Fragment, useEffect, useState} from 'react';
import {useClearCacheCtx} from 'react-clear-cache';
import {RefreshCw} from 'react-feather';
import {Button} from "reactstrap";
import {useTranslation} from "react-i18next";


const ClearCacheComponent = (props) => {

	const {t, i18n} = useTranslation();
	const [mounted, setMounted] = useState(false);
	const {isLatestVersion, emptyCacheStorage} = useClearCacheCtx();

	const [responsiveMaxWidth, setResponsiveMaxWidth] = useState(() => {
		return window.innerWidth < 900
	});

	const handleResize = () => {
		setResponsiveMaxWidth(window.innerWidth < 900)
	}

	useEffect(() => {
		window.addEventListener('resize', handleResize)
		window.addEventListener('scroll', handleScroll)

		return () => {
			window.removeEventListener('resize', handleResize)
			window.removeEventListener('scroll', handleScroll)
		}
	}, [])


	const handleScroll = () => {
		const navbar = document.querySelector('.navbar-static .main-menu');
		const cacheWarning = document.querySelector('#cache_warning');

		if (cacheWarning && navbar) {
			const cacheWarningTop = cacheWarning.getBoundingClientRect().top;
			if (cacheWarningTop < 0) {
				navbar.style.top = `0px`;
			} else {
				navbar.style.top = `50px`;
			}
		}
	}

	return (
		<Fragment>
			{!isLatestVersion ?
				<div id={"cache_warning"}
					 style={{
						 zIndex: 1006,
						 height: 50,
						 fontFamily: 'Montserrat',
						 padding: '0.5rem',
						 background: '#ffd5d5',
					 }} className={"text-danger w-100 text-center"}>
					<span className={""}>{!responsiveMaxWidth ? t("New Version Description") : t("New Version Released")}</span>
					<Button
						outline
						onClick={(e) => {
							e.preventDefault();
							emptyCacheStorage();
						}}
						color={'primary'}
						size={'sm'}
						className={'ms-1'}
					>
						<RefreshCw size={15} style={{marginRight: !responsiveMaxWidth ? '.4rem' : null}}/>
						{!responsiveMaxWidth ? <span className={"mb-0"}>{t("Update")}</span> : null}
					</Button>
				</div> : null}
		</Fragment>
	);
};

export default ClearCacheComponent;